import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-header-help",
  "use": "app-icon-header-help-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app-icon-header-help\"><g transform=\"translate(-1 -1)\" stroke=\"#9EA4B3\" stroke-width=\"2\" stroke-linecap=\"round\" fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"12\" cy=\"12\" r=\"10\" /><path d=\"M12 17.017V18M12 14v-1.22c0-.392.608-.952.98-1.141 0 0 2.02-.783 2.02-2.155C15 8.112 13.79 7 12.299 7c-.971 0-1.823.471-2.299 1.178\" stroke-linejoin=\"round\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol